export * from "./localization/public";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/behaviors/public.js
// module id = 1080
// module chunks = 0